import React from 'react';
import EmptyIcon from "@material-ui/icons/Info";
import CircularProgress from 'material-ui/CircularProgress';
import {appConstants} from "../_constants";

export const EmptyRecord = ({message}) => (
    <div style={{textAlign: 'center'}}>
        <EmptyIcon  style={{fontSize:"60px"}}/>
        <p>{message}</p>
    </div>
);
export const InlinePageRequesting = () => (
    <div style={{textAlign: 'center'}}>
        <CircularProgress size={60} thickness={6} color={`${appConstants.DANGER_COLOR}`}/>
    </div>
);



// WEBPACK FOOTER //
// ./src/utils/PageUtility.js